import { registerComponent, createMessage, loading } from "helpers";
import WYATTElement from "wyatt";
import StoreAvailability from "store-availability";

registerComponent(
  "quick-add-quantity",
  class QuickAddQuantity extends WYATTElement {
    constructor() {
      super();

      this.StoreAvailability = new StoreAvailability(this);

      this.addPanel = this.querySelector('[data-quick-add-panel="add"]');
      this.quantityPanel = this.querySelector(
        '[data-quick-add-panel="quantity"]',
      );
      this.valueDisplay = this.querySelector(".quick-add-quantity__value");
      this.buttons = this.querySelectorAll(".quick-add-quantity__button");
      this.quantity = 0;

      this.onCartUpdated = this.handleCartUpdated.bind(this);
      this.onPreferredStoreChange = this.handlePreferredStoreChange.bind(this);

      this.buttons.forEach((button) => {
        button.addEventListener("click", this.onButtonClick.bind(this));
      });

      this.setState(0);
      this.validate();
    }

    connectedCallback() {
      this.dataset.storeNumber = this.StoreAvailability.storeNumber;

      this.syncCartQuantityFromCart();
      this.setState(this.quantity);

      this.subscribe(WYATT.PubSub.events.cartUpdated, this.onCartUpdated);

      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.onPreferredStoreChange,
      );
    }

    get variantId() {
      return Number(this.config.variant);
    }

    get errorMessage() {
      return WYATT.t.quantity_validation.error_message.replace(
        "{{ quantity }}",
        this.quantityAvailable,
      );
    }

    get quantityAvailable() {
      return Number(this.dataset.quantityAvailable);
    }

    syncCartQuantityFromCart() {
      this.quantity = WYATT.Cart.getQuantityForVariant(this.variantId);
    }

    handleCartUpdated() {
      this.syncCartQuantityFromCart();
      this.setState(this.quantity);
    }

    handlePreferredStoreChange(store) {
      this.dataset.storeNumber = store?.store_number;
      this.validate();
    }

    setState(quantity) {
      this.quantity = quantity;
      this.dataset.state = quantity > 0 ? "quantity" : "add";

      if (quantity > 0) {
        this.valueDisplay.textContent = quantity;
        this.quantityPanel.hidden = false;
      } else {
        this.valueDisplay.textContent = "";
        this.quantityPanel.hidden = true;
      }

      this.checkDisabledState();
    }

    setQuantity(quantity, syncCart = true) {
      if (!syncCart) {
        this.setState(quantity);
        return;
      }

      this.updateCartQuantity(quantity);
    }

    async onButtonClick(event) {
      event.preventDefault();

      const delta = event.currentTarget.name === "plus" ? 1 : -1;
      const nextValue = this.quantity + delta;

      if (delta > 0) {
        if (
          this.dataset.quantityAvailable &&
          this.quantity >= this.quantityAvailable
        ) {
          createMessage(this.errorMessage, { type: "error", minDelay: 5000 });
          return;
        }
      }

      if (nextValue < 0) {
        return;
      }

      await this.updateCartQuantity(nextValue);
    }

    async updateCartQuantity(quantity) {
      loading.add(this);

      const response = await WYATT.Cart.changeCartQuantity(
        this.variantId,
        quantity,
      );

      loading.remove(this);

      if (response) {
        this.setState(WYATT.Cart.getQuantityForVariant(this.variantId));
        WYATT.Cart.provideCartCountFeedback();
      }
    }

    async validate() {
      await this.StoreAvailability.getAvailability();

      const { quantityAvailable } = this.StoreAvailability;

      if (quantityAvailable != null) {
        this.dataset.quantityAvailable = quantityAvailable;
      }

      this.checkDisabledState();
    }

    checkDisabledState() {
      const maxQuantity = Number(this.dataset.quantityAvailable);

      this.buttons.forEach((button) => {
        if (button.name === "plus") {
          button.disabled =
            Number.isFinite(maxQuantity) && this.quantity >= maxQuantity;
        } else {
          button.disabled = this.quantity <= 0;
        }
      });
    }
  },
);
